export default __webpack_public_path__ + "de34463b02bcc80bbc34f50fd93e3fe8.png";